import { IActionWithParam } from '../common.types';
import { ChatMessage, CopilotResponse, UserCareerRole } from '@careerhub/api';

export enum CopilotActionType {
  SEND_MESSAGE = 'SEND_MESSAGE',
  RECEIVE_MESSAGE = 'RECEIVE_MESSAGE',
  START_OVER = 'START_OVER',
  STOP_GENERATING = 'STOP_GENERATING',
  SET_USER_INFO = 'SET_USER_INFO',
}

export const sendMessage = (message: ChatMessage): IActionWithParam<ChatMessage> => ({
  type: CopilotActionType.SEND_MESSAGE,
  param: message,
});

export const startOver = () => ({
  type: CopilotActionType.START_OVER,
});

export const receiveMessage = (message: CopilotResponse): IActionWithParam<CopilotResponse> => ({
  type: CopilotActionType.RECEIVE_MESSAGE,
  param: message,
});

export const stopGenerating = () => ({
  type: CopilotActionType.STOP_GENERATING,
});

export const setUserInfo = (userContext: UserCareerRole): IActionWithParam<UserCareerRole> => ({
  type: CopilotActionType.SET_USER_INFO,
  param: userContext,
});
